export const GET_CONSULTATION_LIST =
  "/api/v1/doctor-schedules/get-procedure-list";
export const GET_SCHEDULED_TIME = "/api/v1/schedules_with_delay";
export const CREATE_UPDATE_DELAY_SCHEDULE =
  "/api/v1/create_update_delay_schedules";
export const GET_AFFECTED_APPOINTMENTS =
  "/api/v1/doctor-schedules/delay-appointments";
export const MARK_DELAY_API = "/api/v1/doctor-schedules/mark-delay";
